import * as _ from 'lodash';
import { LoteExamNames } from '../../../../ng2/shared/constants/lote-exam-names.constant';
import { NextRegentsAdminDate } from '../../../../ng2/shared/constants/next-regents-admin-date.constant';

angular.module('nv.shared.modals').controller('LoteSchedulerCtrl', LoteSchedulerCtrl);

function LoteSchedulerCtrl(LoteSchedulerModal, $scope, $mdDialog, UtilitiesService) {
  const nullExamText = 'None';
  const loteExamNames = _.map(LoteExamNames, examName => {
    return LoteSchedulerModal.getFormattedExamName(examName);
  }).sort();
  let loteExamNamesColumns;

  loteExamNames.unshift(nullExamText);
  loteExamNamesColumns = UtilitiesService.chunkArrIntoCols(loteExamNames, 3);

  $scope.NextRegentsAdminDate = NextRegentsAdminDate;
  $scope.selectedExam = LoteSchedulerModal.getFormattedExamName() || nullExamText;
  $scope.loteExamsCol1 = loteExamNamesColumns[0];
  $scope.loteExamsCol2 = loteExamNamesColumns[1];
  $scope.loteExamsCol3 = loteExamNamesColumns[2];

  $scope.confirm = function() {
    $mdDialog.hide(
      $scope.selectedExam && $scope.selectedExam !== nullExamText ? $scope.selectedExam.toUpperCase() : null,
    );
  };

  $scope.cancel = () => {
    $mdDialog.cancel();
  };
}
